<template>
  <p>
    <template
      v-if="
        stripePaymentWhen === 'deferred_payment' &&
        campsiteAllowOverrideImmediate
      "
    >
      <translate tag="strong"> Optional full payment available. </translate
      ><br /><br />
    </template>
    <template v-if="campsiteRefundPolicy === 'other'">
      <!-- Campsite has 'other' policy so leave this out.  -->
    </template>
    <translate v-else-if="campsiteRefundPolicy === 'no penalties'">
      Balance refunds: no penalties for cancellation
    </translate>
    <translate
      v-else-if="refundUntilDate && campsitePaymentTiming === 'arrive'"
      :tt="{ refundUntilDate }"
    >
      Balance due on cancellation from {refundUntilDate, puDate, full}
    </translate>
    <translate v-else-if="isNotRefundableAfterDate" :tt="{ refundUntilDate }">
      Balance not refundable after {refundUntilDate, puDate, full}
    </translate>
    <translate
      v-else-if="stripePaymentWhen === 'deferred_payment' && refundUntilDate"
      :tt="{ refundUntilDate }"
    >
      Balance refunds available until {refundUntilDate, puDate, full}
    </translate>
  </p>
</template>

<script lang="ts">
import type { PaymentTiming } from '../../../../campsite-details/types'
import type { StripePaymentWhen } from '../../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class BookingBalance extends Vue {
  @Prop()
  balanceDueDate: string

  @Prop()
  campsiteAllowOverrideImmediate: boolean

  @Prop({ required: true, type: String }) // type, to remove warning
  campsitePaymentTiming: PaymentTiming

  @Prop()
  campsiteRefundPolicy: string

  @Prop()
  refundUntilDate: string

  @Prop({ required: true, type: String }) // type, to remove warning
  stripePaymentWhen: StripePaymentWhen

  get isNotRefundableAfterDate() {
    return (
      this.refundUntilDate &&
      this.balanceDueDate &&
      this.refundUntilDate === this.balanceDueDate
    )
  }
}

export default toNative(BookingBalance)
</script>
<style scoped>
p {
  margin-bottom: 1em;
}
</style>
